import React, { FC } from 'react';
import { View } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getNCFileByPartId } from '@reducers/manufacture';
import { getPartByID } from '@reducers/parts';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';

interface PartDetailsBatchEventsChangeProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const PartDetailsBatchEventsChangeComponent: FC<PartDetailsBatchEventsChangeProps> = ({
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
  batch,
}) => {
  const title = useTitle();

  usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    operationsSearch,
  });

  const productionBatchId = batch.data?.productionBatchId;

  return (
    <DetailsPageWrapper title={title.batch}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.CHANGE, productionBatchId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const PartDetailsBatchEventsChange = connect(({ batch: { batch } }) => ({ batch }), {
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsBatchEventsChangeComponent);

export { PartDetailsBatchEventsChange };
